const isUndefined = (minMax?: number) => undefined === minMax
const isGreater = (than: number) => (v: number): boolean => v >= than
const isLower = (than: number) => (v: number): boolean => v <= than

export const isValidForMaxValues = (v: number, max?: number): boolean =>
  isUndefined(max) || isLower(max)(v)
export const isValidForMinValues = (v: number, min?: number): boolean =>
  isUndefined(min) || isGreater(min)(v)
